import { FunctionComponent } from "react";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouteObject,
  RouterProvider,
} from "react-router";
import ErrorBoundary from "components/error-boundary";
import { userRoutes } from "./routes/user";
import NotFoundView from "views/not-found/view";
import OrganizationProvider from "providers/organization";
import TranslationProvider from "providers/translation";
import { adminRoutes } from "./routes/admin";
import { sharedRoutes } from "./routes/shared";
import { publicRoutes } from "./routes/public";

// define list of routes
const routes = [
  // root redirects to admin login
  { path: "/", element: <Navigate to="/admin/login" /> },

  // include other routes with with ... array spread
  ...publicRoutes,
  ...sharedRoutes,
  ...userRoutes,
  ...adminRoutes,

  // to catch them all
  { path: "*", element: <NotFoundView /> },
] as RouteObject[];

// create a router and wrap some contexts/utilities
export const router = createBrowserRouter([
  {
    path: "/",
    children: routes,
    element: (
      <TranslationProvider>
        <OrganizationProvider>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </OrganizationProvider>
      </TranslationProvider>
    ),
  },
]);

// the actual component
const Router: FunctionComponent = () => <RouterProvider router={router} />;

export default Router;
